@let isCreationAllowed = creationAllowed();

<!------------------------------

      Page Actions

------------------------------->
<div *sbPageAction>
  @if (isCreationAllowed) {
    <button
      sb-button-primary
      type="button"
      color="green"
      icon="plus"
      sbTooltip="{{ 'lang.attributedatatypes.create' | translate }}" container="body"
      [iconButton]="true"
      [sbRouterLink]="util.RoutingID.attributeCreate"
      [queryParams]="{attrType: selectedType, returnTo: util.getPageLink()}">
    </button>
  }

  <button
    type="button"
    sb-button-primary
    icon="refresh"
    [iconButton]="true"
    [color]="'blue'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" container="body"
    placement="top">
  </button>
</div>
<!------------------------------

     Table Wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.headlines.attributes' | translate}}"
  [itemName]="'attributes'"
  [itemsData]="attributes"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
>

  <!------------------------------

      Filter

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
      filterID="search"
    >

      <sb-filter-section
        title="{{'lang.globals.type' |translate}}" icon="selection"
        [hideValueCount]="true"
        [initiallyExpanded]="true"
        classes="tw-flex tw-flex-col tw-gap-2">
        <sb-filter-list-select filterID="attrType" [isSingleSelect]="true" [minSelectedItems]="1" [defaultSelected]="selectedType"
                               [items]="attributeTypes" [unselectableByTag]="false"></sb-filter-list-select>
      </sb-filter-section>

    </sb-filter-panel>
  </div>

  <!------------------------------

      Table Header

------------------------------->
  <ng-template #thead>

    <tr>
      <th>{{ 'lang.globals.id' | translate }}</th>
      <th>{{ 'lang.deviceFilterList.scope' | translate }}</th>
      <th>{{ 'lang.globals.name' | translate }}</th>
      <th>{{ 'lang.globals.description' | translate }}</th>
      <th class="sticky-col last-col"> {{ 'lang.globals.action' |translate }}</th>
    </tr>
  </ng-template>
  <!------------------------------

  Table Body

------------------------------->
  <ng-template #tbody let-attribute>
    <tr>
      <td>{{ attribute?.id }}</td>
      <td>{{ attribute?.global ? 'Global' : ('lang.globals.client' |translate) }}</td>
      <td>
        <sb-comp-link
          [title]="attribute?.name"
          [link]="util.RoutingID.attributeEdit"
          [tooltip]="'lang.globals.edit' | translate"
          [pathParams]="[{id: 'attributeID', value: attribute?.id}]"
          [queryParams]="{attrType: selectedType, returnTo: util.getPageLink()}">
        </sb-comp-link>
      </td>
      <td>{{ attribute?.description }}</td>
      <td class="sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="attribute.sbButtons ?? []"
        ></sb-split-button>
      </td>
    </tr>
  </ng-template>
  <!------------------------------

 Card Element

------------------------------->

  <!-- no card element -->

</sb-table-wrapper-new>
